export default [
  {
    path: '/roles',
    name: 'roles',
    component: () => import('@/views/pages/role/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.roles',
      resource: 'role',
      action: 'list',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          active: true,
        },
      ],
    },
  },
  {
    path: '/roles/add',
    name: 'add-role',
    component: () => import('@/views/pages/role/Add.vue'),
    meta: {
      pageTitle: 'breadcrumb.roles',
      resource: 'role',
      action: 'create',
      breadcrumb: [
        {
          text: 'breadcrumb.add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/roles/modify/:id',
    name: 'modify-role',
    component: () => import('@/views/pages/role/Modify.vue'),
    meta: {
      pageTitle: 'breadcrumb.roles',
      resource: 'role',
      action: 'edit',
      breadcrumb: [
        {
          text: 'breadcrumb.modify',
          active: true,
        },
      ],
    },
  },
]
